(() => {
  const threshold = (base, overrides, config, currency) => {
    const entries = new Map();
    String(overrides || '').split(/[\n,;]/).forEach(line => {
      const [key, raw] = line.split('=').map(value => value.trim());
      if (key && raw && Number(raw) > 0) entries.set(key.toUpperCase(), Number(raw));
    });
    const override = entries.get(`${config.country}:${config.currency}`) ?? entries.get(config.currency);
    if (override !== undefined) return Math.round(override * 100);
    const rate = config.currency === config.baseCurrency ? 1 : currency?.active === config.currency ? Number(currency.rate) : NaN;
    return Number(base) > 0 && rate > 0 ? Math.round(Number(base) * 100 * rate) : null;
  };
  const shipping = (config, total, currency) => {
    const advertised = threshold(config.threshold, config.overrides, config, currency);
    const actual = threshold(config.actualThreshold, config.actualOverrides, config, currency);
    if (!advertised || !actual || !Number.isFinite(total) || total < 0) return null;
    return { remaining: Math.max(0, advertised - total), unlocked: total >= actual, pending: total >= advertised && total < actual, progress: Math.min(100, Math.max(0, total / advertised * 100)) };
  };
  const readMoney = (text, currency) => {
    const parts = new Intl.NumberFormat('en-US', { style: 'currency', currency }).formatToParts(1234.5);
    const decimal = parts.find(part => part.type === 'decimal')?.value || '.';
    const cleaned = String(text).replace(new RegExp(`[^0-9${decimal === '.' ? '\\.' : decimal}-]`, 'g'), '').replace(decimal, '.');
    return cleaned && Number.isFinite(Number(cleaned)) ? Math.round(Number(cleaned) * 100) : null;
  };
  const deal = (price, percent, quantity = 1) => (price - Math.round(price * percent / 100)) * quantity;
  const offerPrice = (variant, percent = 0, quantity = 1) => {
    const regular = Number(variant?.price || 0);
    const price = deal(regular, percent, quantity);
    const reference = percent > 0 ? regular : Number(variant?.compare_at_price || 0);
    const compare = Number.isFinite(reference) && reference > 0 && reference * quantity > price ? reference * quantity : null;
    return { price, compare };
  };
  const api = { shipping, readMoney, deal, offerPrice };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.PetsUpsellOffers = api;
})();
